import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import { useHistory } from 'react-router-dom';

import Button from 'src/components/atoms/Button';
import Logo from 'src/logos/Logo';
import { clearState, forgotPassword, resetPassword } from 'src/slices/auth';
import css from './Login.module.scss';
import InputWrap from 'src/components/molecules/InputWrap';
import { handleStatus } from 'src/slices/utils';
import { setEmail } from 'src/slices/signup';

export default function ResetPass() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token } = useParams();
  const { status } = useSelector((state) => state.auth);

  const [credentials, setCredentials] = useState({
    email: '',
  });

  // Input Validation
  const handleForgotPassword = (e) => {
    e.preventDefault();

    if (!credentials.email) {
      toast.warning(`"Email" is a required field`);
      return;
    }
    if (
      !credentials.email.match(
        /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
      )
    ) {
      toast.warning('Please input a valid email address');
      return;
    }
    dispatch(forgotPassword(credentials));
  };

  useEffect(() =>
    handleStatus(status.forgotPassword, () => dispatch(clearState(status.forgotPassword)), {
      isSuccess: {
        callback: () => {
          dispatch(setEmail(credentials.email));
          navigate('/login');
        },
      },
    }),
  );
  return (
    <>
      <div className={css['page']}>
        <Logo width="260px" />
        <form className={css['box']} onSubmit={handleForgotPassword}>
          <div className={css.component}>
            <h3 className={css.title}>Reset Password</h3>
            <div className={css.inputs}>
              <InputWrap
                label="Email"
                component={
                  <input
                    value={credentials.email}
                    onChange={(e) =>
                      setCredentials({
                        ...credentials,
                        email: e.target.value,
                      })
                    }
                    type="email"
                  />
                }
              />
            </div>
            <div className={css['buttons']}>
              <Button
                label="Send Password Reset Email"
                color="white"
                variant={'primary'}
                type="submit"
                // tabindex="-1"
                action={handleForgotPassword}
              />
            </div>
          </div>
        </form>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
}
